module.exports = __webpack_public_path__ + "img/wallet-line.6601f037.svg";